@if (
  {
    footerDrawerIsVisible: footerDrawerService.isVisible$ | async,
    isLastVersionReaded: isLastVersionReaded$ | async,
    modalColor: modalService.color$ | async,
    modalFullPage: modalService.fullPage$ | async,
    modalIsVisible: modalService.isVisible$ | async,
    routeData: routeData$ | async,
    showExitIntegration: showExitIntegration$ | async,
    username: username$ | async,
    isAdmin: isAdmin$ | async,
    isViaLiberaDeposit: isViaLiberaDeposit$ | async,
    showUserMenu: showUserMenu$ | async,
    tsIntroVideoLink: tsIntroVideoUrl$ | async,
    isNomeCmd: isNomeCmd$ | async,
    tsIntroLinkLand: tsIntroLinkLand$ | async,
    isEmbedded: isEmbedded$ | async,
    isLybera: isLybera$ | async,
    user: user$ | async,
    elevioError: elevioError$ | async,
  };
  as pipeData
) {
  <ng-container opEmbedNavigation>
    <app-tour-template-component #tour></app-tour-template-component>
    <bil-app-shell
      #appShell
      [showHeader]="
        pipeData.routeData?.layout?.showHeader &&
        !(isIntegration || pipeData.isLybera) &&
        !pipeData.isEmbedded
      "
      [showSidebar]="pipeData.routeData?.layout?.showSidebar && !pipeData.isEmbedded"
      logo="/assets/images/scritta_bilancio in cloud.png"
    >
      @if (
        pipeData.routeData?.layout?.showHeader &&
        !(isIntegration && pipeData.isLybera) &&
        !pipeData.isEmbedded
      ) {
        <bil-app-shell-header>
          <app-help></app-help>
          <app-change-office
            joyrideStep="manage10"
            [stepContent]="tour.customContent"
            [stepContentParams]="{
              descr: descrStudio,
              title: 'Il tuo studio',
              link: 'dashboardVideo',
            }"
          >
          </app-change-office>
          <app-user-context-menu
            [username]="pipeData.username"
            [isAdmin]="pipeData.isAdmin"
          ></app-user-context-menu>
        </bil-app-shell-header>
      }
      @if (pipeData.routeData?.layout?.showSidebar && !pipeData.isEmbedded) {
        <bil-app-shell-sidebar>
          @if (isIntegration || pipeData.isLybera) {
            <bil-app-shell-sidebar-item
              (click)="showExitIntegration$.next(true)"
              (mouseleave)="balloonHidden()"
            >
              <bil-icon
                name="far fa-arrow-left"
                (mouseenter)="balloonShow($event, 'Esci', 'bottom')"
              ></bil-icon>
              Esci
            </bil-app-shell-sidebar-item>
          }
          @if (!pipeData.isViaLiberaDeposit) {
            <bil-app-shell-sidebar-item
              to="/user/dashboard"
              (mouseleave)="balloonHidden()"
              joyrideStep="manage1"
              [stepContent]="tour.customContent"
              [stepContentParams]="{
                descr: descrDashboard,
                title: 'Dashboard',
                link: 'dashboardVideo',
              }"
              [prevTemplate]="tour.prevButton"
              [nextTemplate]="tour.nextButton"
              [doneTemplate]="tour.doneButton"
              [counterTemplate]="tour.counter"
              id="idMainDashboard"
            >
              <bil-icon
                [name]="isIntegration || pipeData.isLybera ? 'far fa-chart-pie-alt' : 'far fa-home'"
                (mouseenter)="balloonShow($event, 'Dashboard', 'top')"
              ></bil-icon>
              Dashboard
            </bil-app-shell-sidebar-item>
          }
          @if (!pipeData.isViaLiberaDeposit) {
            <bil-app-shell-sidebar-item
              to="/elencoCliente"
              (mouseleave)="balloonHidden()"
              joyrideStep="manage2"
              [stepContent]="tour.customContent"
              [stepContentParams]="{ descr: descrCli, title: 'Clienti', link: 'dashboardVideo' }"
              id="idMainClienti"
            >
              <bil-icon
                name="far fa-address-book"
                (mouseenter)="balloonShow($event, 'Clienti', 'top')"
              ></bil-icon>
              Clienti
            </bil-app-shell-sidebar-item>
          }

          <bil-app-shell-sidebar-item
            *ngxPermissionsOnly="'fascicolo/read'"
            (mouseleave)="balloonHidden()"
            to="/elencofascicoli"
            joyrideStep="manage3"
            [stepContent]="tour.customContent"
            [stepContentParams]="{
              descr: descrFascicoli,
              title: 'Fascicoli',
              link: 'dashboardVideo',
            }"
          >
            <bil-icon
              name="far fa-folders"
              (mouseenter)="balloonShow($event, 'Fascicoli', 'top')"
            ></bil-icon>
            Fascicoli
          </bil-app-shell-sidebar-item>
          <!-- <bil-app-shell-sidebar-item
          *ngxPermissionsOnly="'deposito/read'"
          (mouseleave)="balloonHidden()"
          to="/deposito"
          joyrideStep="manage4"
          [stepContent]="tour.customContent"
          [stepContentParams]="{ descr: descrDeposito, title: 'Depositi', link: 'dashboardVideo' }"
          >
          <bil-icon
            name="far fa-archive"
            (mouseenter)="balloonShow($event, 'Depositi', 'top')"
          ></bil-icon>
          Depositi
        </bil-app-shell-sidebar-item> -->
          @if (!pipeData.isViaLiberaDeposit) {
            <bil-app-shell-sidebar-item
              *ngxPermissionsOnly="'redazione-documenti-azienda/read'"
              to="/documentale"
              (mouseleave)="balloonHidden()"
              joyrideStep="manage5"
              [stepContent]="tour.customContent"
              [stepContentParams]="{
                descr: descrDocumenti,
                title: 'Documenti',
                link: 'dashboardVideo',
              }"
            >
              <bil-icon
                name="far fa-file-alt"
                (mouseenter)="balloonShow($event, 'Documenti', 'top')"
              ></bil-icon>
              Documenti
            </bil-app-shell-sidebar-item>
          }
          @if (isIntegration || pipeData.isLybera) {
            <bil-app-shell-sidebar-item-no-link
              (click)="showUserMenu()"
              (mouseleave)="balloonHidden()"
            >
              <bil-icon
                name="far fa-user"
                (mouseenter)="balloonShow($event, 'Utenti', 'top')"
              ></bil-icon>
              Utenti
            </bil-app-shell-sidebar-item-no-link>
          }
          <bil-app-shell-sidebar-item-no-link
            #NoteDiRilascio
            id="NoteDiRilascio"
            (mouseleave)="balloonHidden()"
            (click)="openNoteDiRilascio()"
          >
            <bil-icon
              name="far fa-list"
              style="position: absolute"
              (mouseenter)="balloonShow($event, 'Note', 'top')"
            ></bil-icon>
            @if (!pipeData.isLastVersionReaded) {
              <bil-icon name="app-note-rilascio-red-circle"></bil-icon>
            }
            Note di rilascio
          </bil-app-shell-sidebar-item-no-link>
          <bil-app-shell-sidebar-item-no-link (click)="startTour()" (mouseleave)="balloonHidden()">
            <bil-icon
              name="far fa-map-signs"
              (mouseenter)="balloonShow($event, 'Guida', 'top')"
            ></bil-icon>
            Guida
          </bil-app-shell-sidebar-item-no-link>
        </bil-app-shell-sidebar>
      }
      <app-note-rilascio
        [(isVisible)]="isNoteRilascioVisible"
        [target]="'#NoteDiRilascio'"
        (onReleaseNoteClick)="onOpenReleaseNote()"
      ></app-note-rilascio>
      <bil-app-shell-main #mainDiv>
        <router-outlet></router-outlet>
      </bil-app-shell-main>
      @if (pipeData.footerDrawerIsVisible) {
        <app-footer-drawer></app-footer-drawer>
      }
      @if (pipeData.modalIsVisible) {
        <bil-modal
          class="app-grid-align"
          [color]="pipeData.modalColor"
          [fullPage]="pipeData.modalFullPage"
        ></bil-modal>
      }
      <bil-toast></bil-toast>
      <bil-modal-popup
        [visible]="pipeData.showExitIntegration"
        (callBackConfirm)="callBackExit($event)"
        [title]="'Torna al contesto contabilità'"
        [titleButtonConfirm]="'Esci da Bilancio'"
        [titleButtonCancel]="'Rimani'"
      >
        Tornando al contesto contabilità uscirai da Bilancio.
      </bil-modal-popup>
      @if (isIntegration || pipeData.isLybera) {
        <app-user-context-menu
          [username]="pipeData.username"
          [isAdmin]="pipeData.isAdmin"
          [isVisible]="pipeData.showUserMenu"
        >
        </app-user-context-menu>
      }
      <bil-balloon> </bil-balloon>
      <bil-loader-count></bil-loader-count>
    </bil-app-shell>
    <bil-modal-popup
      class="app-bil-modal-custom"
      [visible]="pipeData.isNomeCmd === 'NICEE'"
      [titleButtonConfirm]="'Continua'"
      type="confirm"
      [showCancel]="false"
      [title]="'Conosci il Bilancio di TeamSystem Studio'"
      (callBackConfirm)="callBackExitIntro()"
    >
      Gentile cliente, il Bilancio di TeamSystem Studio è l’unico strumento per la predisposizione
      dei Bilanci che potrai utilizzare dal 2024, scopri subito tutte le sue caratteristiche.<br />
      <span style="white-space: nowrap; padding-bottom: 12px"
        >Per ulteriori approfondimenti e per iscriverti ai corsi di formazione
        <a target="blank" [href]="pipeData.tsIntroLinkLand">clicca qui.</a></span
      >
      <video
        #video
        class="app-responsive-video"
        controls
        autoplay="autoplay"
        (canplay)="video.play()"
        (loadedmetadata)="video.muted = true"
      >
        <source [src]="pipeData.tsIntroVideoLink" />
      </video>
      <span style="padding-top: 12px"
        >Se invece hai bisogno di consultare vecchi Bilanci completati su NICEE, puoi utilizzare il
        comando NICEEOLD.</span
      >
    </bil-modal-popup>
    @if (!(isIntegration || pipeData.isLybera || pipeData.elevioError)) {
      <vapor-angular-help-center
        [accountId]="elevioAccountId"
        [user]="pipeData.user"
        widgetlabel="Hai bisogno di aiuto?"
      ></vapor-angular-help-center>
    }
  </ng-container>
}
